import { render, staticRenderFns } from "./CoffretHortense.vue?vue&type=template&id=00a5beed&scoped=true&"
import script from "./CoffretHortense.vue?vue&type=script&lang=js&"
export * from "./CoffretHortense.vue?vue&type=script&lang=js&"
import style0 from "./CoffretHortense.vue?vue&type=style&index=0&id=00a5beed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a5beed",
  null
  
)

export default component.exports